import { render } from "./categories.vue?vue&type=template&id=a9138c80&scoped=true"
import script from "./categories.vue?vue&type=script&lang=js"
export * from "./categories.vue?vue&type=script&lang=js"

import "./categories.vue?vue&type=style&index=0&id=a9138c80&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9138c80"]])

export default __exports__